module.exports = __webpack_public_path__ + "img/6.fc3625c5.png";